import DishWithVariationsItem from '../components/DishWithVariationsItem';
import CartItemHOC from 'HOC/CartItem';

export default CartItemHOC(DishWithVariationsItem);
